
import { useState } from "react";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Rooms", path: "/rooms-hall-in-varanasi" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact Us", path: "/contact" },
    { name: "Banquet", path: "/banquet-in-varanasi" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">

          {/* Left: Logo */}
          <NavLink to="/" className="flex items-center gap-3">
            <img
              src="logo.png"
              alt="Hotel Prakash Palace"
              className="h-11 w-11 rounded-full object-cover border-2 border-blue-600"
            />
            <div className="leading-tight">
              <h1 className="text-lg font-bold text-gray-800">
                Hotel Prakash
              </h1>
              <p className="text-xs text-gray-500 -mt-1">
                Palace
              </p>
            </div>
          </NavLink>

          {/* Center Menu */}
          <div className="hidden md:flex space-x-10 font-medium">
            {menuItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `relative transition
                  ${isActive ? "text-blue-600" : "text-gray-700 hover:text-blue-600"}
                  after:content-[''] after:absolute after:left-0 after:-bottom-1
                  after:h-[2px] after:bg-blue-600
                  after:transition-all
                  ${isActive ? "after:w-full" : "after:w-0 hover:after:w-full"}`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </div>

          {/* Right Button */}
          <div className="hidden md:block">
            <NavLink
              to="/appointment"
              className="bg-gradient-to-r from-yellow-600 to-orange-500 
              text-white px-5 py-2 rounded-full shadow-md
              hover:scale-105 transition inline-block"
            >
              Appointment
            </NavLink>
          </div>

          {/* Mobile Button */}
          <div className="md:hidden">
            <button
              onClick={() => setOpen(!open)}
              className="text-gray-700 text-3xl"
            >
              ☰
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white shadow-xl px-6 pb-6 pt-4 space-y-3">
          {menuItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block font-medium ${
                  isActive ? "text-yellow-500" : "text-gray-700 hover:text-orange-400"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}

          <NavLink
            to="/appointment"
            onClick={() => setOpen(false)}
            className="block text-center mt-4 bg-gradient-to-r from-yellow-600 to-orange-500 
            text-white py-2 rounded-full shadow"
          >
            Appointment
          </NavLink>
        </div>
      )}
    </nav>
  );
}
